import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Page from '@Containers/Page';
import { LinkElement } from '@els/els-react--link-element';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { initHealthCheckRequester } from './healthCheckRequester';

const supportCenterLink = 'https://service.elsevier.com/app/home/supporthub/reaxys/';

// eslint-disable-next-line sonarjs/no-globals-shadowing
function Error({ retry }) {
  useEffect(() => {
    if (!retry) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return initHealthCheckRequester(); // returns stop function
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page
      withHeader
      headerType="clean"
      withFooter
      pageClassName="react-page-static login-limit-page"
      className="react-page-static__wrapper">
      <h1 className="react-page-static__heading">
        <span className="ss-mug" />
        &nbsp; Internal Server Error
      </h1>
      <div className="react-page-static__content">
        <p>
          This service is currently unavailable, we apologize for any inconvenience. Please try again later.
          <br />
          Thanks for your patience.
        </p>
        <p>Please contact our support team if you have any questions</p>
        <p>
          <LinkElement
            data-e2e="contact-support-team-link"
            href={supportCenterLink}
            className="e2e-contact-support-team"
            isExternal
            iconSprite="ChevronRight"
            iconSize="s"
            iconRight>
            Contact Support Team
          </LinkElement>
        </p>
      </div>
    </Page>
  );
}

Error.propTypes = {
  retry: PropTypes.bool,
};

export default withCombinedRouteParams(Error);
